<template>
  <RouterView />
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useHead } from "@vueuse/head";

const SITE_URL = "https://mti-dev.ru";

export default {
  name: "App",
  components: {},
  setup() {
    const route = useRoute();

    useHead({
      link: computed(() => [
        {
          rel: "canonical",
          href: `${SITE_URL}${route.path === "/" ? "/" : route.path}`,
        },
      ]),
      meta: computed(() => {
        const path = route.path.toLowerCase();
        const isPrivatePath =
          path === "/admin" ||
          path.startsWith("/admin/") ||
          path === "/employee" ||
          path.startsWith("/employee/") ||
          path === "/employees" ||
          path.startsWith("/employees/") ||
          path === "/vacancies" ||
          path.startsWith("/vacancies/");

        return isPrivatePath
          ? [{ name: "robots", content: "noindex, nofollow" }]
          : [{ name: "robots", content: "index, follow" }];
      }),
    });
  },
};
</script>
<style>
@import "@/assets/css/reset.css";
@import "@/assets/css/init.css";
@import "@/assets/css/dark.css";
</style>
